import React from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  OutlinedInput,
  Box,
  Chip,
  Typography
} from '@mui/material';
import { FilterDropdownProps } from '../../../types';

const FilterDropdown: React.FC<FilterDropdownProps> = ({
  label,
  options,
  selectedValue,
  onChange,
  multiple = false,
  placeholder = 'Select',
  disabled = false,
  sx = {},
  renderCustomValue
}) => {
  const handleChange = (event: any) => {
    const value = event.target.value;
    onChange(value);
  };

  // Get display label for single selection
  const getSingleDisplayValue = () => {
    if (!selectedValue) return placeholder;
    const option = options.find(opt => opt.value === selectedValue);
    return option ? option.label : selectedValue;
  };

  return (
    <FormControl sx={{ minWidth: 200, ...sx }} size="small" disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedValue}
        size='small'
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        multiple={multiple}
        renderValue={renderCustomValue || (multiple ? (selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {(selected as string[]).map((value) => {
              const option = options.find(opt => opt.value === value);
              return (
                <Chip 
                  key={value} 
                  label={option?.label || value}
                  size="small"
                />
              );
            })}
          </Box>
        ) : () => (
          <Typography variant="body2">
            {getSingleDisplayValue()}
          </Typography>
        ))}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterDropdown;